import CustomiseProjectView from 'CustomiseProject/container/CustomiseProjectView';

export default CustomiseProjectView;
